import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import GameDetailPage from '@/components/GameDetailPage.vue';
import TermsOfService from '@/components/TermsOfService.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import { gamesBySlug } from '@/data/games';

const routes = [
  { path: '/', component: HomePage, meta: { title: 'Zearloops | Independent Game Studio' } },
  { path: '/game/:title', component: GameDetailPage },
  { path: '/terms-of-service', component: TermsOfService, meta: { title: 'Terms of Service | Zearloops' } },
  { path: '/privacy-policy', component: PrivacyPolicy, meta: { title: 'Privacy Policy | Zearloops' } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reducedMotion ? 'auto' : 'smooth';

    if (savedPosition) {
      return reducedMotion ? { ...savedPosition, behavior } : savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        behavior
      };
    }

    return {
      top: 0,
      behavior
    };
  }
});

router.afterEach((to) => {
  if (to.path.startsWith('/game/')) {
    const game = gamesBySlug[to.params.title];
    document.title = game ? `${game.title} | Zearloops` : 'Game not found | Zearloops';
    return;
  }

  document.title = to.meta.title || 'Page not found | Zearloops';
});

export default router;
